var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBrandkitUpload = function SvgIconBrandkitUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.52 8.56v8.572M7.66 11.418l2.857-2.857 2.857 2.857"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.599 13.875a4.56 4.56 0 1 1-.611-9.101.33.33 0 0 0 .299-.182 5.526 5.526 0 0 1 10.726 1.3.35.35 0 0 0 .247.286 3.9 3.9 0 0 1-.87 7.697"
  })));
};
export default SvgIconBrandkitUpload;